import { ref } from 'vue'

/** @type {import('vue').Ref<null | { title: string, message: string, confirmText: string, cancelText: string, resolve: (v: boolean) => void }>} */
export const appConfirmState = ref(null)

/**
 * @param {string} message
 * @param {string} [title]
 * @param {{ confirmButtonText?: string, cancelButtonText?: string }} [options]
 */
export function appConfirm(message, title = '', options = {}) {
  if (import.meta.server) return Promise.resolve(false)
  return new Promise((resolve) => {
    appConfirmState.value = {
      title: title || 'Warning',
      message,
      confirmText: options.confirmButtonText || 'OK',
      cancelText: options.cancelButtonText || 'Cancel',
      resolve,
    }
  })
}

export function closeAppConfirm(result) {
  const state = appConfirmState.value
  if (!state) return
  appConfirmState.value = null
  state.resolve(result)
}
